// extracted by mini-css-extract-plugin
export default {"title":"Card_title__5o-Gu","content":"Card_content__+m6SL","contentText":"Card_contentText__JtJgG"};